import React from 'react';

const DokumentyDoPobrania = (props) => {
  return (
    <React.Fragment>
      <h3 className="page-header firstColor">Dokumenty do pobrania</h3>

      <h4 className="secondColor">Warunki ubezpieczenia</h4>

      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Ogólne_warunki_ubezpieczenia_TUW_PZUW_Opieka_Medyczna.pdf">
            Ogólne Warunki Grupowego Ubezpieczenia TUW PZUW Opieka Medyczna (OM)
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Dokument_zawierający_informację_o_produkcie_ubezpieczeniowym_(OM).pdf">
            Dokument zawierający informację o produkcie ubezpieczeniowym (OM)
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/WYCIĄG_ZAPISÓW_Z_UMOWY_DATUS_czerwiec_2026.pdf">
            Wyciąg zapisów z umowy
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tvp-tuwpzuw.uspartner.pl/public-assets/tvp/2026/2/Załącznik_nr_6A_-_zakres_świadczeń_zdrowotnych_Standard.pdf">
            Zakres STANDARD
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/2/Załącznik_nr_7_-_zakres_świadczeń_zdrowotnych_Komfort.pdf">
            Zakres KOMFORT
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/2/Załącznik_nr_8_zakres_świadczeń_zdrowotnych_Komfort_Plus.pdf">
            Zakres KOMFORT PLUS
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/2/Załącznik_nr_8_-_zakres_świadczeń_zdrowtnych_Optimum.pdf">
            Zakres OPTIMUM
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Chirurgia_jednego_dnia_dla_zakresu_Optimum.pdf">
            Chirurgia jednego dnia dla zakresu Optimum
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tvp-tuwpzuw.uspartner.pl/public-assets/tvp/2026/Cennik_refundacyjny.pdf">
            Cennik refundacyjny – dla zakresu Standard
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/lista_placowek_medycznych.xlsx">
            Wykaz placówek medycznych
          </a>
        </li>
      </ul>

      <h4 className="secondColor">Instrukcje</h4>

      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Ulotka_Opieka_Medyczna_Współpracownicy.pdf">
            Ulotka
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Zwrot_kosztów_odpowiedzi_na_podstawowe_pytania.pdf">
            Zwrot kosztów – odpowiedzi na podstawowe pytania
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tvp-tuwpzuw.uspartner.pl/public-assets/tvp/2026/moje.pzu_jak_umówić_się_na_badania.pdf">
            mojePZU – jak umówić się na badania
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tvp-tuwpzuw.uspartner.pl/public-assets/tvp/2026/Jak_odwołać_wizytę_lub_badanie.pdf">
            Jak odwołać wizytę
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Dodanie_dziecka_do_profilu_mojePZU.pdf">
            Dodanie dziecka do profilu rodzica na mojePZU
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://tvp-tuwpzuw.uspartner.pl/public-assets/tvp/2026/E-Recepta_Kontynuacja_leczenia.pdf">
            E-Recepta - Kontynuacja leczenia
          </a>
        </li>
      </ul>

      <h4 className="secondColor">Wnioski</h4>

      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/Formularz_zgłoszeniowy_refundacja.pdf">
            Formularz zgłoszeniowy – Refundacja
          </a>
        </li>
      </ul>

      <h4 className="secondColor">Inne</h4>
      <ul>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="/public-assets/tvp/2026/RODO_Informacja_Administratora danych osobowych.pdf">
            RODO – Obowiązek informacyjny
          </a>
        </li>
      </ul>
    </React.Fragment>
  );
};

export default DokumentyDoPobrania;
